import { render, staticRenderFns } from "./ResultTestDetailChild.vue?vue&type=template&id=b8a76a7c&scoped=true"
import script from "./ResultTestDetailChild.vue?vue&type=script&lang=js"
export * from "./ResultTestDetailChild.vue?vue&type=script&lang=js"
import style0 from "./ResultTestDetailChild.vue?vue&type=style&index=0&id=b8a76a7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a76a7c",
  null
  
)

export default component.exports